import { Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
export default class ABTestBranchActionMetadata extends Record({
  actionType: ActionTypes.AB_TEST_BRANCH
}, 'ABTestBranchActionMetadata') {}